import { render, staticRenderFns } from "./ModalAddNewCommunityInfrastructure.vue?vue&type=template&id=4227b914&"
import script from "./ModalAddNewCommunityInfrastructure.vue?vue&type=script&lang=js&"
export * from "./ModalAddNewCommunityInfrastructure.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddNewCommunityInfrastructure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports